import script from "./VideoPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts&setup=true"

import "./VideoPlayer.vue?vue&type=style&index=0&id=5bd46f85&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd46f85"]])

export default __exports__